import React from 'react';
import ContactSection from '../ContactSection';
import Map from '../Map';

export default function Contact() {
  return (
    <>
      <ContactSection />
      <Map />
    </>
  );
}
